import React, { useCallback, useRef } from "react";
import FocusLock from "react-focus-lock";
import { useToggle } from "react-use";
import { Overlay, Popper, useLayerContext, EmojiIcon, IconButton } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { ReactionTypesPalette } from "./ReactionTypesPalette.jsx";
import { keyCodes } from "../../utils/key_codes.jsx";

export const StartReacting = ({ className, placement, onClose, ...rest }) => {
  const ref = useRef();
  const { zIndex } = useLayerContext();
  const [open, toggle] = useToggle();

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === keyCodes.escape) {
        event.preventDefault();
        toggle(false);
      }
    },
    [toggle]
  );

  const onCloseTimeout = useCallback(() => {
    setTimeout(() => {
      typeof onClose === "function" && onClose();
    }, 0);
  }, [onClose]);

  const handleClose = useCallback(() => {
    toggle(false);
    onCloseTimeout();
  }, [toggle, onCloseTimeout]);

  return (
    <div
      className={classNames("start_reacting", { "start_reacting-open": open }, className)}
      onKeyDown={handleKeyDown}
    >
      <IconButton
        ref={ref}
        variant="text gray"
        active={open}
        onClick={toggle}
        size="small"
        className="target-message-reactions"
      >
        <EmojiIcon />
      </IconButton>
      {open ? (
        <Overlay
          onClick={handleClose}
          disableBackgroundColor
        />
      ) : null}
      <Popper
        anchorEl={ref.current}
        open={open}
        style={{ zIndex }}
        placement={placement}
      >
        <FocusLock returnFocus={{ preventScroll: true }}>
          <ReactionTypesPalette
            {...rest}
            onClick={handleClose}
            className="reactions_picker start_reacting_palette"
          />
        </FocusLock>
      </Popper>
    </div>
  );
};

StartReacting.propTypes = {
  className: PropTypes.string,
  placement: PropTypes.string,
  onClose: PropTypes.func,
};
StartReacting.defaultProps = {
  placement: "top",
};
